//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	data(){
		return{}
	},
	methods:{
		closeDialog(){
			this.$parent.showConfirm = false;
		}
	},
	props:['meetingData','meetingTime','meetingCity','meetingPeople','joinFee','submitFn']
}



// WEBPACK FOOTER //
// ./src/components/Confirm.vue